import { onboardAlgo } from "./onboard-algo"
import { getWorkingDates } from "@/state/reportv2/convert"
import { ReportFormData } from "@/state/report"
import { getTimeDifference } from "@/utils/time"
import { defaultProfession } from "@/state/draft/profession"
import { ShortAddress } from "../maps/utils/address"
import { getProfessionConfig } from "@/constants/getConfig"
import { PlainDate } from "@/utils/date"

export const generateTrips = async (
	reportForm: ReportFormData,
	addresses: ShortAddress[]
) => {
	const workingDays = getWorkingDates(
		[
			PlainDate.from(reportForm.period.range[0]),
			PlainDate.from(reportForm.period.range[1]),
		],
		reportForm.workingSchedule.workingWeekDays,
		// holidays.map((x) => x.getTime())
		[]
	)
	const dailyTimeLimit = getTimeDifference(
		reportForm.workingSchedule.workingHours[0],
		reportForm.workingSchedule.workingHours[1]
	)
	const profession = reportForm.professionType || defaultProfession
	const configTimeSpent = getProfessionConfig(profession)?.timeSpent

	const timeSpentAtLocation =
		reportForm.timeSpent.timeAtLocation.to || configTimeSpent?.timeAtLocation.to || 0

	const timeSpentAtOffice =
		reportForm.timeSpent.timeInOffice.to || configTimeSpent?.timeInOffice.to || 0

	return onboardAlgo({
		totalMiles: +reportForm.mileage.totalMiles,
		workingDays,
		startAddress: reportForm.hqAddress,
		dailyTimeLimit,
		timeSpentAtLocation: timeSpentAtLocation,
		timeSpentAtOffice: timeSpentAtOffice,
		addresses,
		startTime: reportForm.workingSchedule.workingHours[0],
	})
}
